import '../../../legacy/jubileemobility/vehicle.view';
import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';

(() => {
    const gallery = document.querySelector('.vehicle-gallery');
    if (!gallery) {
        return;
    }

    new Swiper(gallery.querySelector('.vehicle-gallery__main .swiper'), {
        modules: [Pagination],
        slidesPerView: 1,
        pagination: {
            clickable: true,
            el: '.vehicle-gallery__pagination',
        },
        breakpoints: {
            540: {
                enabled: false,
            }
        }
    });

    new Swiper(gallery.querySelector('.vehicle-gallery__thumbs .swiper'), {
        modules: [Navigation],
        slidesPerView: 3,
        spaceBetween: 10,
        speed: 250,
        navigation: {
            prevEl: gallery.querySelector('.vehicle-gallery__navigation-button--prev'),
            nextEl: gallery.querySelector('.vehicle-gallery__navigation-button--next'),
        },
        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            1280: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
        }
    })
})();
